module.exports = __webpack_public_path__ + "img/exhibition2.d3ee6c87.png";